import { Dialog, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import Options from "../UsageMethods/Options";
import ShowGraph from "../UsageMethods/ShowGraph";
import TduForm from "../form/TduForm";
import SmtForm from "../form/SmtForm";
import { useDispatch, useSelector } from "src/store";
import { setViewInStore } from "src/slices/bkvReducer";

interface UsageModalType {
  open: boolean;
  handleClose: Function;
}

export type ViewTypes = "options" | "showUsageGraph" | "tdu" | "smt";

const UsageModal: FC<UsageModalType> = ({ open, handleClose }) => {
  const [landscape, setLandscape] = useState(false);
  const state = useSelector((state) => state.bkv);
  const dispatch = useDispatch();

  const setView = (newView: ViewTypes) => {
    dispatch(setViewInStore(newView));
  };

  useEffect(() => {
    function orientationChange() {
      const angle = window.screen.orientation.angle;
      const _landscape = angle === 90 || angle === 180;
      setLandscape(_landscape);
    }
    orientationChange();
    window.addEventListener("orientationchange", orientationChange);
    return () => {
      window.removeEventListener("orientationchange", orientationChange);
    };
  }, []);

  const ShowView = ({ view }) => {
    switch (view) {
      case "options":
        return <Options handleClose={handleClose} changeView={setView} />;
      case "showUsageGraph":
        return <ShowGraph handleClose={handleClose} changeView={setView} />;
      case "tdu":
        return <TduForm handleClose={handleClose} changeView={setView} />;
      case "smt":
        return <SmtForm handleClose={handleClose} changeView={setView} />;
      default:
        <Typography>Not Implemented</Typography>;
    }
  };

  return (
    <Dialog className="" open={open} onClose={() => handleClose("usageModal")}>
      <ShowView view={state.view} />
      {open && (
        <style>{`
                    .MuiDialog-paper{
                        max-width: 1128px;
                        overflow-x: hidden;
                        position: relative;
                        border-radius: 32px;
                        margin: 0px;
                        min-height: ${landscape ? "100vh" : "auto"};
                        background-color: #fff
                    }
                    @media(min-width:768px){
                    .MuiDialog-paper{
                      min-width:50%;
                    }
                    }
                    @media(max-width:400px){
                        .MuiDialog-paper{
                            max-width: 100%;
                            overflow-x: hidden;
                            position: relative;
                            border-radius: 0;
                            min-height:100vh;
                            margin:0
                        }
                    }
                `}</style>
      )}
    </Dialog>
  );
};
export default UsageModal;
